import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ApmFaIconComponent, ButtonComponent, IconComponent } from '@mitsubishi/shared/ui';

import { EXPIRING_MARKUP_RESOURCE_IDS } from '../../expiring-markup.constants';

export interface ExpiringMarkupInfoDialogData {
  count: number;
}

const WPL_ROUTE = '/pricing-list';

@Component({
  selector: 'apm-expiring-markup-info-dialog',
  templateUrl: './expiring-markup-info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ApmTranslatePipe, ButtonComponent, ApmFaIconComponent],
})
export class ExpiringMarkupInfoDialogComponent {
  readonly #router = inject(Router);
  readonly #dialogRef = inject(MatDialogRef<ExpiringMarkupInfoDialogComponent>);

  protected readonly resourceIds = EXPIRING_MARKUP_RESOURCE_IDS;
  protected readonly count = inject<ExpiringMarkupInfoDialogData>(MAT_DIALOG_DATA).count;
  protected readonly isWplRoute = this.#router.url.startsWith(WPL_ROUTE);

  protected goToWpl(): void {
    this.#router.navigate([WPL_ROUTE]);
    this.#dialogRef.close();
  }
}
